import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/seoData';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            {/* Brand column */}
            <div className="lg:w-1/4">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-file-list-3-line text-white text-base"></i>
                </div>
                <span className="font-heading text-lg font-bold text-foreground-950">ItaobuySheet</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {footerLinks.description}
              </p>
              <div className="flex gap-3 mt-5">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer">
                  <i className="ri-shopping-bag-3-line text-foreground-700"></i>
                </a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer">
                  <i className="ri-global-line text-foreground-700"></i>
                </a>
              </div>
            </div>

            {/* Link columns */}
            {footerLinks.columns.map((col) => (
              <div key={col.title} className="lg:w-1/4">
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-4">
                  {col.title}
                </h4>
                <ul className="flex flex-col gap-3">
                  {col.links.map((link) => (
                    <li key={link.text}>
                      {link.external ? (
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                        >
                          {link.text}
                        </a>
                      ) : (
                        <Link
                          to={link.url}
                          className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                        >
                          {link.text}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom bar */}
          <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span>&copy; 2026 ItaobuySpreadsheet. All rights reserved.</span>
              <span className="hidden sm:inline text-foreground-300">|</span>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-500 transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <span className="hidden sm:inline text-foreground-300">|</span>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-500 transition-colors cursor-pointer">
                Terms of Service
              </a>
            </div>
            <p className="text-xs text-foreground-400">
              Powered by <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-500 transition-colors cursor-pointer">ItaobuySpreadsheet</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}